
namespace RioERP.Orders {
    export class CustomerGiftCardsColumns {
        static columnsKey = 'Orders.CustomerGiftCards';
    }
}